import React, { Key, useState } from 'react';
import { FormInstance } from 'antd';

import FavouriteStar from '@/comp/FavouriteStar/FavouriteStar';

interface FavouriteStartCellProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  form: FormInstance;
  disabled: boolean;
}

const FavouriteStartCell: React.FC<FavouriteStartCellProps> = ({ field, form, disabled }) => {
  const currentValue = form.getFieldValue(['stationAndSubscriptions', field?.name, 'isFavorite']);
  const [isFavourite, setIsFavourite] = useState(currentValue);

  const onToggleFavourite = () => {
    form.setFieldValue(['stationAndSubscriptions', field?.name, 'isFavorite'], !currentValue);
    setIsFavourite(!currentValue);
  };

  return (
    <FavouriteStar
      isFavourite={isFavourite}
      size="small"
      className="favourite-star-column"
      disabled={disabled}
      onToggle={onToggleFavourite}
    />
  );
};

export default FavouriteStartCell;
